import pdfIcon from "../images/pdfIcon.svg";
import cloudDownload from "../images/cloudDownload.svg";
import { IoCopyOutline } from "react-icons/io5";
import { FaCheck } from "react-icons/fa6";
import { useState } from "react";
import DownloadLoadingModal from "./DownloadLoadingModal";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function StepperKyc({ timeline, orderId, reinitiateHandler }) {
  // console.log(timeline);
  const lender_id = 6;
  const [loading, setLoading] = useState(false);
  // console.log(timeline);

  return (
    <>
      {" "}
      <nav aria-label="Progress" className="!z-0">
        <ol role="list" className="overflow-hidden mt-4 !z-0">
          {timeline.map((step, stepIdx) => (
            <li
              key={step.name}
              className={classNames(
                stepIdx !== timeline.length - 1 ? "pb-7" : "",
                "relative"
              )}
            >
              {step.status === "complete" ? (
                <>
                  {stepIdx !== timeline.length - 1 ? (
                    <div
                      aria-hidden="true"
                      className="absolute left-3 top-4 -ml-px mt-0.5 h-full w-[1px] bg-[#00394d]"
                    />
                  ) : null}
                  <span className="group relative flex items-start">
                    <span className="flex h-9 items-center">
                      <span className="relative z-0 flex h-6 w-6 items-center justify-center rounded-full bg-[#0BA300] ">
                        check Icon
                      </span>
                    </span>
                    <span className="ml-4 flex min-w-0 flex-col">
                      <span className="text-sm font-medium">{step.name}</span>

                      <span className="text-xs text-gray-500">
                        {step.description}
                      </span>
                    </span>
                  </span>
                </>
              ) : step.status === "current" ? (
                <>
                  {stepIdx !== timeline.length - 1 ? (
                    <div
                      aria-hidden="true"
                      className="absolute left-3 top-4 -ml-px mt-0.5 h-full w-[1px] bg-[#6F6F6F]"
                    />
                  ) : null}
                  <span aria-current="step" className="group relative flex ">
                    <span aria-hidden="true" className="flex h-9 items-center">
                      <span className="relative z-0 flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#0BA300] bg-white">
                        <span className="h-2 w-2 rounded-full bg-[#0BA300]" />
                      </span>
                    </span>
                    <span
                      className={`ml-4 flex min-w-0 flex-col ${
                        lender_id !== 6 ? "mt-[4px]" : "mt-[8px]"
                      } `}
                    >
                      <div className=" w-[414px] flex justify-between items-center ">
                        <p className=" text-sm font-semibold ">{step.name}</p>
                        {/* {true && (
                        <button className="  border border-[#0069c3] text-[#0069c3] rounded  py-[2px] px-2 text-[13px] font-medium">
                          Reinitiate
                        </button>
                      )} */}
                      </div>
                      {step.last && (
                        <p className=" text-[#8b8b8b] text-[10px] font-medium ">
                          29-05-2024 10:29
                        </p>
                      )}
                      {lender_id !== 6 && (
                        <div className=" mt-3 flex justify-between">
                          {step.download?.length > 1 &&
                            step.download?.map((item, index) => (
                              <DownloadButton key={index} name={item} />
                            ))}
                          {step.download?.length === 1 && (
                            <DownloadButton
                              name={step.download[0]}
                              fullWidth={true}
                            />
                          )}
                        </div>
                      )}

                      {/* <span className="text-sm font-medium">{step.name}</span>
                    <span className="text-xs text-gray-500">
                      {step.description}
                    </span> */}
                    </span>
                  </span>
                </>
              ) : step.status === "failed" ? (
                <>
                  {stepIdx !== timeline.length - 1 ? (
                    <div
                      aria-hidden="true"
                      className="absolute left-3 top-4 -ml-px mt-0.5 h-full w-[1px] bg-[#d30d00]"
                    />
                  ) : null}
                  <span
                    aria-current="step"
                    className="group relative flex items-start"
                  >
                    <span aria-hidden="true" className="flex h-9 items-center">
                      <span className="relative z-0 flex h-6 w-6 items-center justify-center rounded-full border-2 border-[#d30d00] bg-white">
                        <span className="h-2 w-2 rounded-full bg-[#d30d00]" />
                      </span>
                    </span>
                    <span className="ml-4 flex min-w-0 flex-col">
                      <span className="text-sm font-medium">{step.name}</span>

                      <span className="text-xs text-gray-500">
                        {step.description}
                      </span>
                    </span>
                  </span>
                </>
              ) : (
                <>
                  {stepIdx !== timeline.length - 1 ? (
                    <div
                      aria-hidden="true"
                      className="absolute left-3 top-4 -ml-px mt-0.5 h-full w-[1px] bg-[#6F6F6F]"
                    />
                  ) : null}
                  <span className="group relative flex items-center">
                    <span aria-hidden="true" className="flex h-9 items-center">
                      <span className="relative z-0 flex h-6 w-6 items-center justify-center rounded-full bg-white">
                        <span className="bg-[#6F6F6F] h-2 w-2 rounded-full" />
                      </span>
                    </span>
                    <div className="ml-4 flex w-full justify-between items-center ">
                      <div className="text-sm font-medium text-gray-500">
                        {step.name}
                      </div>
                      {step.reinitiateStatus && (
                        <div className=" flex items-center gap-3">
                          <LinkCopyComponent step={step} />

                          <button
                            onClick={() => {
                              reinitiateHandler(step?.initiateMethod);
                            }}
                            className="  border border-[#0069c3] text-[#0069c3] rounded  py-[2px] px-2 text-[13px] font-medium"
                          >
                            Reinitiate
                          </button>
                        </div>
                      )}

                      {/* <span className="text-xs text-gray-500">
                      {step.description}
                    </span> */}
                    </div>
                  </span>
                </>
              )}
            </li>
          ))}
        </ol>
      </nav>
      {loading && <DownloadLoadingModal />}
    </>
  );
}

const DownloadButton = ({ name, fullWidth }) => {
  return (
    <button
      className={` border border-[#e6ebed] rounded-lg flex items-center p-[6px] ${
        fullWidth ? "w-full" : "w-[200px]"
      }`}
    >
      {name === "Credit Score" ? (
        <>
          <div className=" h-full flex flex-col justify-between items-start ml-[6px] ">
            <p className="text-xs font-semibold"> {name}</p>
            <p className=" text-[10px] font-semibold text-[#8b8b8b]">740</p>
          </div>
        </>
      ) : (
        <>
          <img src={pdfIcon} alt="" className="w-6 h-6" />
          <div className=" h-full flex flex-col justify-between items-start ml-[6px] ">
            <p className="text-xs font-semibold"> {name}.PDF</p>
            <p className=" text-[10px] font-semibold text-[#8b8b8b]">1 MB</p>
          </div>
          <img src={cloudDownload} alt="" className=" ml-auto w-5 h-5" />
        </>
      )}
    </button>
  );
};

const LinkCopyComponent = ({ step }) => {
  const diabledCopyStyle = {
    width: "15px",
    height: "15px",
    color: "#c6c6c6",
    backgroundColor: "#f3f3f3",
  };
  const enabledCopyStyle = {
    width: "15px",
    height: "15px",
    color: "#0069c3",
    backgroundColor: "#ffffff",
  };

  const handleCopy = (link, index) => {
    if (!document.hasFocus()) {
      return;
    }
    if (!link) return;
    navigator.clipboard.writeText(link);
  };
  const [status, setStatus] = useState(false);
  return (
    <>
      {!status && (
        <>
          {" "}
          <button
            disabled={!step.url}
            onClick={(event) => {
              event.stopPropagation();
              if (!step.url) return;
              setStatus(true);
              setTimeout(() => {
                setStatus(false);
              }, 3000);
              handleCopy(step.url);
            }}
            className={` p-[4px] border  rounded ${
              !step.url
                ? "border-[#c6c6c6] bg-[#f3f3f3] cursor-default"
                : "border-[#0069c3] bg-white "
            }`}
          >
            <IoCopyOutline
              style={step.url ? enabledCopyStyle : diabledCopyStyle}
            />
          </button>
        </>
      )}
      {status && (
        <p
          className="text-xs  font-medium  items-center text-[#47b971] border border-[#47b971] rounded-[4px] inline-flex bg-white px-[5px] py-[3px]"
          onClick={(event) => event.stopPropagation()}
        >
          <span className=" mr-1">
            <FaCheck />{" "}
          </span>
          Link Copied
        </p>
      )}
    </>
  );
};
